import { isAfter } from 'date-fns';
import { createJob } from './job';

export function createProJob (data) {
  const job = createJob(data);

  return {
    ...job,
    match: job.matches.find(match => match.pro === Number(data.proId)),
    get showNotificationIndicator () {
      return isAfter(new Date(this.match.time_updated), new Date(this.match.time_seen_pro));
    },
  };
}
